import React from 'react'
import PhoneInput from 'react-phone-input-2'
import { useField, ErrorMessage } from 'formik'
import 'react-phone-input-2/lib/style.css'
import './styles.css'

const PhoneInputField = ({ country, hasError, showValidation, ...props }) => {
  const [field] = useField(props)
  const { onChange } = field

  const newHandleChange = (val) => {
    onChange({ target: { name: props.name, value: val } })
  }

  return (
    <>
      <PhoneInput
        {...props}
        country={country || 'in'}
        dropdownClass="country-list-dd"
        inputClass="phone-input"
        containerClass={`phone-input-container${hasError ? ' error' : ''}`}
        placeholder=""
        {...{ ...field, onChange: newHandleChange }}
        {...props}
      />
      {showValidation && (
        <ErrorMessage
          component="div"
          name={props.name}
          style={{ color: 'red', marginTop: '-10px' }}
        />
      )}
    </>
  )
}
export default PhoneInputField
